module.exports = __webpack_public_path__ + "img/20201213_133546.184e0796.jpg";